import { Provide, Component } from "vue-property-decorator"
import * as moment from "moment"
import { ConstantValuesItem } from "@/store/models/common"
import util from "@/lib/util"
import { EzAddress, IEzAddress, UserCategory } from "@/asdcom/apiproxy/apiproxy.dto"
import AbpBase from "@/lib/abpbase"
import { Asdcom } from "./appservice.asdcom"
import AsdcomBase from "@/lib/asdcombase"

export function L(value: string, source?: string, ...argus: string[]): string {
  // abp.log.debug({"BaseComponent L":value});
  return new AbpBase().L(value, source, ...argus)
}

export interface FormatAddressResult {
  line1?: string
  line2?: string
}

export default class BaseComponent extends AsdcomBase {

  v_errors: any

  get buildInfo() {
    return this.$store.getters['asdcom/app/buildInfo'];
  }

  public getConstValuesSorted(values: ConstantValuesItem[]): ConstantValuesItem[] {
    let sortedList = values.sort((a, b) => (this.L(a.name) > this.L(b.name)) ? 1 : -1)
    return sortedList;
  }

  public get isStaffAdminUser(): boolean {
    //UserCategory.StaffAdminUser
    return util.abp.auth.hasPermission("Pages.Tenant.StaffAdminUser") as boolean;
  }

  getSelectList(list: ConstantValuesItem[]): any[] {
    let ret: any[] = [];
    list.forEach(i => { ret.push({ text: L(i.localizedName), value: i.value }) });
    return ret;
  }

  public get isLoading() {
    return this.$appsvs.isLoading;
  }

  public get RemindersCount(): number {
    if (!this.$store.state.vcponlineok.remindersCount) { return 0; }
    else {
      return this.$store.state.vcponlineok.remindersCount;
    }
  }

  public get ApplicantRequestsCount(): number {
    if (!this.$store.state.vcponlineok.applicantRequestsCount) { return 0; }
    else {
      return this.$store.state.vcponlineok.applicantRequestsCount;
    }
  }

  public get ClaimTasksCount(): number {
    // abp.log.debug({'BaseComponent.ts claimtasks':this.$store.state.vcponlineok.claimTasksCount});
    if (!this.$store.state.vcponlineok.claimTasksCount) { return 0; }
    else {
      return this.$store.state.vcponlineok.claimTasksCount;
    }
  }

  getPageAmount(counter: number) {
    if (!!counter && (counter !== 0)) {
      if (counter > 1) {
        return `(${counter} pages)`;
      } else {
        return `(${counter} page)`;
      }
    }
  }

  // @Provide("$validator")
  // $val = this.$validator

  public async ValidateAll() {
    /// validate all child components.
    var validationArray = this.$children.map(function (child) {
      //abp.log.debug({"validate child":child});
      return child.$validator.validateAll();
    });
    // validate all parent inputs
    validationArray.push(this.$validator.validateAll())

    return Promise.all(validationArray).then((validationResult: boolean[]) => {
      // abp.log.debug({ "security questions validate": validationResult });
      return validationResult.every(isValid => {
        // abp.log.debug({"some":isValid});
        return isValid == true;
      });
    });
  }

  async ValidationResetAll() {
    var validationArray = this.$children.map(function (child) {
      //abp.log.debug({"validate child":child});
      return child.$validator.reset();
    });
    // reset all parent inputs
    validationArray.push(this.$validator.reset())

    return Promise.all(validationArray).then(() => {
      return
    })
  }

  goToNextStep(nextRouteName: string, applicationId: string) {
    const query = { applicationId: applicationId };
    this.$router.push({ name: nextRouteName, query })
  }
  goToPrevStep(prevRouteName: string, applicationId: string) {
    const query = { applicationId: applicationId };
    this.$router.push({ name: prevRouteName, query })
  }

  plainTextToHtml(value: string): string {
    if (value == undefined) {
      return ""
    }
    // replace new lines with br tag.
    value = value.replace(/\n/g, "<br/>")
    return value
  }

  get userName(): string {
    const session = this.$store.state.session;
    return session && session.user && session.user.userName
      ? session.user.userName
      : null;
  }

  hasValue(val: any) {
    return val !== undefined && val !== null && (val + "").trim() !== ""
  }

  formatPhoneNumber(value: any) {
    // const newVal = (this.hasValue(value) && typeof value === 'string') ? value.replace(/(\d{3})(\d{3})(\d{4})/, "($1)$2-$3") : '-';
    return this.hasValue(value) && typeof value === "string"
      ? value
        .replace(/\D/g, "")
        .replace(/^0/, "")
        .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
      : undefined
  }

  public get isIE(): boolean {
    const ua = navigator.userAgent
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
  }

  getDateTime(date: any) {
    let ret: string = "-";
    if (this.hasValue(date)) {
      let caltureName = util.abp.localization.currentCulture.name;
      let timeZoneId: string = util.abp.timing.timeZoneInfo.iana.timeZoneId;

      if (this.isIE) {
        caltureName = util.abp.localization.currentCulture.name + "-US";
        timeZoneId = util.abp.timing.timeZoneInfo.windows.timeZoneId;
      }

      ret = `${new Date(date).toLocaleString(caltureName, {
        timeZone: timeZoneId,
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      })}`
    }
    return ret;
  }

  getDate(date: any) {
    let ret: string = "-";
    abp.log.debug({ 'BaseComponent.ts:': this.hasValue(date) });
    if (this.hasValue(date)) {
      let caltureName = util.abp.localization.currentCulture.name;
      let timeZoneId: string = util.abp.timing.timeZoneInfo.iana.timeZoneId;

      if (this.isIE) {
        caltureName = util.abp.localization.currentCulture.name + "-US";
        timeZoneId = util.abp.timing.timeZoneInfo.windows.timeZoneId;
      }

      ret = new Date(date).toLocaleDateString(caltureName, {
        timeZone: timeZoneId,
        year: "numeric",
        month: "numeric",
        day: "numeric",
      });

    }
    return ret;
  }

  formatDate(date?: Date | moment.Moment) {
    if (this.hasValue(date)) {
      return moment(date).format("l")
    }
    return undefined
  }

  formatDateTime(date?: Date | moment.Moment) {
    if (this.hasValue(date)) {
      return moment(date).format("l LT")
    }
    return undefined
  }

  // getDateFromTo(dateFrom: any, dateTo: any, dateFormat: string = "MM/DD/YYYY") {
  // 	return `${this.getDate(dateFrom, dateFormat)} - ${this.getDate(dateTo, dateFormat)}`;
  // }

  formatAddress(adr: IEzAddress): FormatAddressResult | undefined {
    let ln1: string | undefined = undefined
    let ln2: string | undefined = undefined

    if (this.hasValue(adr.addressLine1) && this.hasValue(adr.addressLine2)) {
      ln1 = `${adr.addressLine1}, ${adr.addressLine2}`
    } else if (this.hasValue(adr.addressLine1)) {
      ln1 = adr.addressLine1
    } else if (this.hasValue(adr.addressLine2)) {
      ln1 = adr.addressLine2
    }
    if (this.hasValue(adr.city)) {
      ln2 = adr.city
    }
    if (this.hasValue(adr.usStateCode)) {
      //const stateId = adr.state; //parseInt(adr.state);
      const stateName = this.getConstName("uSState", adr.usStateCode)
      if (ln2 !== undefined) {
        ln2 += `, ${stateName}`
      } else {
        ln2 = `${stateName}`
      }
    }
    if (this.hasValue(adr.postalCode)) {
      if (ln2 !== undefined) {
        ln2 += ` ${adr.postalCode}`
      } else {
        ln2 = `${adr.postalCode}`
      }
    }
    // let ret = ln1;
    // if (this.hasValue(ln1)) {
    // 	ret += ", " + ln2;
    // } else {
    // 	ret = ln2;
    // }
    const ret: FormatAddressResult = {
      line1: ln1,
      line2: ln2,
    }
    return ret
  }

  getDateFromTo(dateFrom: any, dateTo: any) {
    return `${this.getDate(dateFrom)} - ${this.getDate(dateTo)}`
  }

  convertConstValueToName(list: Array<any>, enumValue: number): string {
    let selectedItems = list.filter(val => {
      return val.value == enumValue
    })

    return selectedItems.length > 0 ? selectedItems[0].name : "-"
  }

  getConstName(constName: string, value?: number | string): string | undefined {
    // abp.log.debug({"getConstName":{constName, value}});
    if (value != undefined) {
      constName = constName.toLowerCase()
      const object = util.abp.constant
      for (const key in object) {
        if (object.hasOwnProperty(key) && key.toLowerCase() == constName) {
          const list = object[key].values as ConstantValuesItem[]
          if (list) {
            const item = list.find(i => i.value == value)
            if (item) {
              let retValue = L(item.localizedName);
              if (retValue == item.localizedName)
                retValue = L(item.name);
              return retValue;
            }
          }
        }
      }
    }
    return undefined
  }

  removeFromConstList(constObj: any, itemsToRemove: string[]) {
    const list: any[] = Object.assign([], constObj.values)

    for (let item in itemsToRemove) {
      const index = list.findIndex(i => {
        return i.name.toLowerCase() == itemsToRemove[item].toLowerCase()
      })
      list.splice(index, 1)
    }

    return list
  }

  removeSelf(constObj: any) {
    const list: any[] = Object.assign([], constObj.values)
    const selfIndex = list.findIndex(i => {
      return i.value == constObj.self
    })
    list.splice(selfIndex, 1)
    return list
  }

  getFullName(prefix?: string, first?: string, middle?: string, last?: string, suffix?: string): string | undefined {
    if (!!first || !!last) {
      return `${prefix || ""} ${first || ""} ${middle || ""} ${last || ""} ${suffix || ""}`
    } else {
      return undefined
    }
  }

  getFullNameOptions(name: { prefix?: string; first?: string; middle?: string; last?: string; suffix?: string }): string | undefined {
    if (!!name && (!!name.first || !!name.last)) {
      return `${name.prefix || ""} ${name.first || ""} ${name.middle || ""} ${name.last || ""} ${name.suffix || ""}`
    } else {
      return undefined
    }
  }

  isObjectEmpty(obj: any): boolean {
    const isEmpty = obj == undefined || Object.values(obj).every(x => x === null || (x + "").trim() === "" || x === undefined)
    return isEmpty
  }

  boolToYesNo(val?: boolean) {
    if (!!val) {
      return L("Yes")
    } else {
      return L("No")
    }
  }

  newLineToHtml(val?: string) {
    if (!val) {
      return ""
    } else {
      return val.replace("\n", "<br/>")
    }
  }

  formatNumber(val?: number) {
    if (!!val) {
      return val.toLocaleString(util.abp.localization.currentCulture.name, { minimumFractionDigits: 2 })
    } else {
      return val
    }
  }

  calculateAgeAtCrimeTime(value1: any, value2: any) {
    const monthDiff = moment(value1).diff((value2), "months", true);
    const yearDiff = moment(value1).diff((value2), "years", true);
    const dayDiff = moment(value1).diff((value2), "days");
    // months calculation
    if (monthDiff < 12 && monthDiff > 0) {
      return `${Math.ceil(monthDiff)} ${this.L("month(s)")}`
      // years calculation
    } else if (yearDiff > 0) {
      return `${Math.ceil(yearDiff)} ${this.L("year(s)")}`;
      // if dates are equal 
    } else if (dayDiff == 0) {
      return `0 ${this.L("month")}`
    } else {
      return undefined;
    }
  }
}
